import service from "../assets/service.png";
import insurance from "../assets/Insurance-amico.svg";
import mutual from "../assets/mutualfunds.svg";
import portfolio from "../assets/portfolio.svg";
import trading from "../assets/trading.svg";
import nft from "../assets/nft.svg";
import loan from "../assets/loan.svg";
// import { Testimonials } from "../components/Testimonials";
import fb from "../assets/facebook.png";  
import xlogo from "../assets/twitter.png";   
import email from "../assets/gmail.png";
import linkedin from "../assets/linkedin.png";
import ig from "../assets/instagram.png";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      link: "/insurance",
      title: "Insurance",
      description:
        "Protect your life, health, and assets with our comprehensive insurance solutions tailored to your needs.",
      image: insurance,
    },
    {
      link: "http://aws3.link/Chnyat",
      title: "Mutual Funds",
      description:
        "Invest in a diversified portfolio of professionally managed mutual funds to grow your wealth steadily.",
      image: mutual,
    },
    {
      link: "http://aws3.link/Chnyat",
      title: "Portfolio Management Services",
      description:
        "Let experts manage your investments with personalized strategies for risk and return optimization.",
      image: portfolio,
    },
    {
      link: "https://diy.sharekhan.com/app/Account/Register?grpcd=4819&type=fr&grpid=4997",
      title: "Online Trading",
      description:
        "Buy and sell stocks, commodities, and other securities through our secure and user-friendly online platform.",
      image: trading,
    },
    {
      link: "http://aws3.link/Chnyat",
      title: "FDs/Bonds",
      description:
        "Earn steady returns with fixed deposits and bonds—ideal for low-risk investors seeking financial stability.",
      image: nft,
    },
    {
      link: "/loans",
      title: "Loans",
      description:
        "Access personal, business, and home loans with flexible repayment options and competitive interest rates.",
      image: loan,
    },
    {
      link: "http://aws3.link/Chnyat",
      title: "Specialised Investments Funds",
      description:
        "Access personal, business, and home loans with flexible repayment options and competitive interest rates.",
      image: portfolio,
    },
    {
      link: "http://aws3.link/Chnyat",
      title: "Alternate Investments Funds",
      description:
        "Access personal, business, and home loans with flexible repayment options and competitive interest rates.",
      image: trading,
    },
  ];

  return (
    <>
      <div className="py-5"></div>
      <section className="container text-center pt-5">
        <h2 className="heading">
          Secure. <span style={{ color: "#76ABAE" }}> Grow.</span> Succeed.
        </h2>
        <p className="content py-2">
          Empowering your financial journey with tailored solutions in
          insurance, loans, and investments.
        </p>
        <div className="d-flex justify-content-center">
          <img
            src={service}
            alt="services"
            className="img-fluid w-100"
            style={{ maxWidth: "600px" }}
          />
        </div>
      </section>
      <div className="py-5"></div>
      <section className="container py-5">
        <div className="py-4 mb-3 text-center">
          {" "}
          <h2 className="heading">
            Our <span style={{ color: "#76ABAE" }}> Services</span>{" "}
          </h2>
        </div>
        <div className="row">
          {services.map((service, idx) => (
            <div className="col-md-6 mb-4" key={idx}>
              <Link to={service.link} className="text-decoration-none">
                <div className="card border-0 p-4 h-100 rounded-4 bg-black">
                  <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center">
                      <img
                        src={service.image}
                        className="img-fluid rounded-start p-3"
                        alt={service.title}
                        style={{ height: "150px" }}
                      />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body d-flex align-items-center justify-content-center">
                        <div>
                          <h5
                            className="card-title  fs-4 pb-2 fw-semibold"
                            style={{ color: "#76ABAE" }}
                          >
                            {service.title}
                          </h5>
                          <p className="card-text content">
                            {service.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </section>
      {/* <div className="py-5"></div> */}
      {/* <section>
        <Testimonials />
      </section> */}
      {/* <div className="py-5"></div> */}
      {/* WAYS TO REACH US */}
      <section className="py-5">
        <div className="py-5"></div>

        <div className="container">
          <h2 className="heading text-center">
            Ways to <span style={{ color: "#76ABAE" }}>Reach</span> Us
          </h2>

          <div className="py-4"></div>

          {/* ROW 1 — 3 CARDS */}
          <div className="row justify-content-center">

            {/* EMAIL */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={email} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>Email</h4>
                <p className="mb-0">aura.financials@gmail.com</p>
              </div>
            </div>

            {/* LINKEDIN */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={linkedin} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>LinkedIn</h4>
                <Link
                  to="https://www.linkedin.com/in/aura-financials-1672911a2/"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura-financials</p>
                </Link>
              </div>
            </div>

            {/* INSTAGRAM */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={ig} alt="" style={{ height: "50px", width: "50px"}} />
                  </div>
                </div>
                <h4>Instagram</h4>
                <Link
                  to="https://www.instagram.com/aura_financials/"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura_financials</p>
                </Link>
              </div>
            </div>
          </div>

          {/* ROW 2 — 2 CARDS CENTERED */}
          <div className="row justify-content-center">

            {/* FACEBOOK */}
            <div className="col-md-4 offset-md-1 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={fb} alt="" style={{ height: "50px", width: "50px" }} />
                  </div>
                </div>
                <h4>Facebook</h4>
                <Link
                  to="https://www.facebook.com/aura.financials.7"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura.financials</p>
                </Link>
              </div>
            </div>

            {/* X (TWITTER) */}
            <div className="col-md-4 mb-4">
              <div
                className="p-4 rounded-4 shadow-lg text-white text-center"
                style={{
                  background: "rgba(255, 255, 255, 0.07)",
                }}
              >
                <div className="d-flex mb-3">
                  <div className="m-auto">
                    <img src={xlogo} alt="" style={{ height: "50px", width: "50px" , borderRadius:"10px"}} />
                  </div>
                </div>
                <h4>X (Twitter)</h4>
                <Link
                  to="https://x.com/aura_financials"
                  className="text-decoration-none text-white"
                >
                  <p className="mb-0">@aura_financials</p>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>
      <div className="py-5"></div>
    </>
  );
};
export default Services;
